<bw-action-article-legacy *ngIf="partnerIntro$ | async as partnerIntro; else spinner">
  <div header-actions>
    <ui-nav-exit-back
      [trackingDetail]="{ event_name: 'lender_alternatives_legal' }"
    ></ui-nav-exit-back>
  </div>
  <div pre-title>
    <div class="partner-logo" [style.background-image]="'url(./assets/acknowledgments_hero.png)'"></div>
  </div>
<!--  <div header-title>-->
<!--    <div class="flex mt-sm">-->
<!--      <typography-legacy title-medium color="var(&#45;&#45;primary-text)">-->
<!--        <div [innerHTML]="partnerIntro.name | translate"></div>-->
<!--      </typography-legacy>-->
<!--    </div>-->
<!--  </div>-->
  <div content-section>
    <brightside-web-required-legal-documents
      [documentsKey]="partnerIntro.legalDocumentsKey"
      [showBackbutton]="false"
      [showCloseButton]="false"
      [ctaKey]="'ACKNOWLEDGMENT'"
      [legalType]="'acknowledgement'"
      (termsSubmittedEvent)="goToPartnerRedirectUrl(partnerIntro)"
    ></brightside-web-required-legal-documents>
  </div>
</bw-action-article-legacy>

<ng-template #spinner>
  <bw-spinner-legacy></bw-spinner-legacy>
</ng-template>
